import { IAdsService } from "../../types/IAdsService";
import { IBid, IProvider } from "../provider";

declare global {
  interface Window {
    apntag: {
      anq: Array<() => void>;
      setPageOpts: (opts: any) => void;
      defineTag: (opts: any) => void;
      showTag: (targetId: string) => void;
      loadTags: (ids?: string[]) => void;
      refresh: (ids: string[]) => void;
      onEvent: (event: string, id: string, cb: (bid?: any) => void) => void;
      offEvent: (event: string, id: string) => void;
    };
  }
}

export class MsnAdsService implements IAdsService {
  constructor() {
    if (!window.apntag) {
      const script = document.createElement('script');
      script.src = 'https://acdn.adnxs.com/ast/ast.js';
      script.async = true;
      (document.head || document.body).appendChild(script);
      window.apntag = window.apntag || {} as any;
      window.apntag.anq = window.apntag.anq || [];
      window.apntag.anq.push(() => {
        window.apntag.setPageOpts({
          member: 280,
          test: location.hostname.includes('localhost') || location.hostname.includes('testing'),
          debug: true,
          disablePsa: true,
          keywords: { flight: 'zoneviewtest' },
          user: {
            externalUid: (document.cookie.match(/MUID=([^;$]+)/) || [])[1],
          },
        });
      });
    }
    window.apntag.anq.push(() => {
      window.apntag.defineTag({
        targetId: 'preroll',
        invCode: 'MCGBNSTR01',
        sizes: [640, 480],
        allowedFormats: ['video'],
        video: {
          frameworks: [1, 2],
        },
      });
    });
  }

  public request(duration = 30, isDev = false): Promise<IBid[]> {
    const adId = 'preroll';
    return new Promise((resolve, reject) => {
      setTimeout(() => resolve([]), 5000);
      window.apntag.anq.push(() => {
        window.apntag.onEvent('adNoBid', adId, () => resolve([]));
        window.apntag.onEvent('adAvailable', adId, (bid) => {
          console.warn(bid);
          window.apntag.offEvent('adAvailable', adId);
          const adUrl = 'data:text/xml;base64,' + btoa(bid.video.content);
          resolve([{ bid: { cpm: bid.cpm }, provider: this.createStubProvider(adUrl) }]);
        });

        window.apntag.loadTags([adId]);
      });
    });
  }

  public retryRequest(): Promise<IBid[]> {
    debugger;
    return Promise.resolve([]);
  }

  public getBid(): Promise<{ cpm: number; bidder: string; url: string; }> {
    return Promise.reject();
  }

  public cleanBids(): void {

  }

  protected createStubProvider(url: string): IProvider {
    return {
      name: 'null',
      configure() { },
      requestBids: () => Promise.resolve([]),
      buildVideoUrl: () => Promise.resolve(url),
    };
  }
}
